import * as React from 'react';
import './style.scss';
import { Button } from 'antd';

const QuantityItem = (props) => {
  const { maxQuantity = 1, onUpdateQuantity = () => {} } = props;
  const [quantity, setQuantity] = React.useState(1);

  const handleDecrement = () => {
    setQuantity((prev) => prev - 1);
    onUpdateQuantity(quantity);
  };

  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
    onUpdateQuantity(quantity);
  };

  const handleChange = (e) => {
    setQuantity(e.target.value);
  };

  return (
    <div className="pd-quantity">
      <div className="pd-quantity-selector">
        <Button
          className="minus"
          disabled={quantity <= 1}
          icon="minus"
          onClick={handleDecrement}
          shape="circle"
          type="primary"
        />
        <input
          className="input"
          min={0}
          max={maxQuantity}
          type="number"
          onChange={handleChange}
          value={quantity}
        />
        <Button
          className="plus"
          disabled={quantity === maxQuantity}
          icon="plus"
          onClick={handleIncrement}
          shape="circle"
          type="primary"
        />
      </div>
    </div>
  );
};

export default QuantityItem;
